import { Alert, Box, Button, Chip, Divider, Icon, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import {
    AccountService,
    CourseDto,
    CourseEmployeeDto,
    CourseService,
    CourseType,
} from "../../../api/psc";
import {
    CardInformation,
    DialogContainer,
    DialogHeader,
    EmptyListMessage,
    PrivilegeAlert,
    Spinner,
} from "../../../components/exports";
import { UserAccessTypes } from "../../../components/shared/PrivilegeAlert";
import { DialogContext } from "../../../contexts/DialogueContext";
import UpsertEmployeeDialog from "../../employees/dialogs/UpsertEmployeeDialog";
import CourseEmployeeListItem from "../components/CourseEmployeeListItem";

export default function RegisterInCourseDialog(props: { courseId: number }) {
    const [course, setCourse] = useState<CourseDto>();
    const [employees, setEmployees] = useState<CourseEmployeeDto[]>([]);
    const [availableCourseCount, setAvailableCourseCount] = useState<number>(0);
    const [fetchingRequirements, setFetchingRequirements] = useState(true);

    const { openDialog } = useContext(DialogContext);

    useEffect(() => {
        fetchRequirements();
    }, []);

    const fetchRequirements = () => {
        setFetchingRequirements(true);

        const courseRequest = CourseService.getCourseById(props.courseId, "1");
        const courseUsersRequest = CourseService.getCourseEmployees(
            props.courseId,
            "1"
        );
        const accountDetailRequest = AccountService.getAccountDetail("1");

        Promise.all([
            courseRequest,
            courseUsersRequest,
            accountDetailRequest,
        ]).then((r) => {
            setCourse(r[0]);
            setEmployees(r[1]);
            setAvailableCourseCount(r[2].availableCourseCount);
            setFetchingRequirements(false);
        });
    };

    const openCreateEmployeeDialog = () => {
        openDialog(<UpsertEmployeeDialog />, (r) => {
            if (r) {
                fetchRequirements();
            }
        });
    };

    return (
        <DialogContainer preferredWith={400}>
            <DialogHeader title="ثبت نام در دوره آموزشی" />

            <PrivilegeAlert access={UserAccessTypes.ManageCourses} />

            <Box sx={{ p: 2 }}>
                {fetchingRequirements && <Spinner />}

                {!fetchingRequirements && (
                    <>
                        <Stack spacing={2}>
                            <CardInformation
                                title="تعداد دوره های قابل ثبت نام"
                                value={
                                    <Chip
                                        size="small"
                                        label={availableCourseCount + " عدد"}
                                        color="secondary"
                                    />
                                }
                            />

                            <CardInformation
                                title="حداکثر تعداد قابل ثبت نام برای هر حساب کاربری"
                                value={
                                    <Chip
                                        size="small"
                                        label={
                                            course.remainingAccountCapacity +
                                            " عدد"
                                        }
                                        color="secondary"
                                    />
                                }
                            />

                            {course.type === CourseType.IN_PERSON && (
                                <Alert severity="warning">
                                    همراه داشتن معرفی نامه حاوی سمت رسمی از شرکت
                                    الزامیست
                                </Alert>
                            )}
                        </Stack>

                        <Divider sx={{ mt: 2, mb: 2 }} />

                        {employees.length === 0 && (
                            <EmptyListMessage message="کاربر یافت نشد لطفا ابتدا یک کاربر ایجاد کنید" />
                        )}

                        <Stack spacing={2} divider={<Divider />}>
                            {employees.map((u) => (
                                <CourseEmployeeListItem
                                    course={course}
                                    onChange={fetchRequirements}
                                    item={u}
                                    key={u.employee.id}
                                />
                            ))}

                            <Button
                                variant="outlined"
                                startIcon={<Icon>add</Icon>}
                                onClick={openCreateEmployeeDialog}
                            >
                                افزودن کاربر
                            </Button>
                        </Stack>
                    </>
                )}
            </Box>
        </DialogContainer>
    );
}
